const styles = theme => ({
  paidAccessBanner: {
    display: 'flex',
    height: '48px',
    padding: '8px',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: '#E5F2FF',
    justifyContent: 'space-between',
    marginBottom: '16px',
  },
  paidAccessBannerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  paidAccessTitle: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
  },
  providerContainer: {
    width: '100%',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },
})

export default styles
